<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="modal-content border-0">
  <div class="modal-header">
    <div class="modal-title">Select new Logo Image</div>
    <button
      type="button"
      class="close btn-close"
      aria-label="Close"
      (click)="close()"
    >
      <span aria-hidden="true">x</span>
    </button>
  </div>

  <div class="modal-body">
    <input
      type="file"
      class="file-input"
      (change)="handleUploadedImage($event)"
      #fileUpload
    />
    <div
      class="btn btn-primary"
      disabled="actionInProgress"
      (click)="fileUpload.click()"
    >
      <span>
        <fa-icon [icon]="faImage"></fa-icon>
      </span>
      Select New Logo Image From Disk
    </div>
    <div>
      Use only <strong>JPEG</strong> or <strong>PNG</strong> image with
      <strong>max size</strong> of <strong>200px x 150px!</strong>
    </div>

    <div *ngIf="!isImageUploaded()" class="text-danger">No Image Selected</div>
    <div *ngIf="isImageUploaded()">
      <div>
        <img #logo [src]="logoImage" (load)="onLoad()" class="thinBorder" />
      </div>

      <div>
        <strong>Image Filename:</strong>
        {{ uploadedFileObject.name }}
      </div>
      <div>
        <strong>Size:</strong>
        {{ uploadedFileObject.size }} bytes
      </div>
      <div>
        <strong>Dimensions:</strong>
        {{ uploadedFileDimensions.width }}px &times;
        {{ uploadedFileDimensions.height }}px
      </div>

      <div class="text-danger" *ngIf="notSupportedMimeType()">
        <strong
          >Unsupported file type. Please use JPEG or PNG format only.</strong
        >
      </div>
      <div class="text-danger" *ngIf="imageTooWide()">
        <strong
          >Selected image exceeds width limit. Allowed maximum is 200px.</strong
        >
      </div>
      <div class="text-danger" *ngIf="imageTooHigh()">
        <strong
          >Selected image exceeds height limit. Allowed maximum is
          150px.</strong
        >
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="close()"
      [disabled]="actionInProgress"
    >
      <span class="oi oi-x"></span>
      Close and Discard
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [ngClass]="{ disabled: !isImageValid() }"
      [disabled]="!isImageValid() || actionInProgress"
      (click)="uploadLogo()"
    >
      <span
        *ngIf="actionInProgress"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
      <span *ngIf="!actionInProgress">
        <fa-icon [icon]="faUpload"></fa-icon>
      </span>
      Save new Logo
    </button>
  </div>
</div>
